export interface IRecordFamiliarizationListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
}

export class RecordFamiliarizationListItem implements IRecordFamiliarizationListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;

    constructor();
    constructor(obj: IRecordFamiliarizationListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
    }
}